import { useTranslation } from 'react-i18next'
import { ORDER_KINDS } from 'service/OrdersService'

import styles from './OrderCreateForm.module.scss'

const OrderCreateForm = ({ drawer, setDrawer, students, busy, onCreate, onCancel }) => {
  const { t } = useTranslation('common')

  return (
    <>
      <div className={styles.field}>
        <label>{t('ordersPage.type')}</label>
        <select
          className="unv-input"
          value={drawer.kind}
          onChange={(e) => setDrawer({ ...drawer, kind: e.target.value })}
        >
          {ORDER_KINDS.map((k) => (
            <option key={k.value} value={k.value}>{k.label}</option>
          ))}
        </select>
      </div>
      <div className={styles.field}>
        <label>{t('ordersPage.student')}</label>
        <select
          className="unv-input"
          value={drawer.student || ''}
          onChange={(e) => setDrawer({ ...drawer, student: Number(e.target.value) })}
        >
          <option value="">—</option>
          {students.map((s) => (
            <option key={s.id} value={s.id}>
              {s.full_name || `${s.surname} ${s.first_name}`} ({s.group?.title || '?'})
            </option>
          ))}
        </select>
      </div>
      <div className={styles.field}>
        <label>{t('ordersPage.title')}</label>
        <input
          className="unv-input"
          value={drawer.title || ''}
          onChange={(e) => setDrawer({ ...drawer, title: e.target.value })}
        />
      </div>
      <div className={styles.field}>
        <label>{t('ordersPage.effectiveDate')}</label>
        <input
          type="date"
          className="unv-input"
          value={drawer.effective_at || ''}
          onChange={(e) => setDrawer({ ...drawer, effective_at: e.target.value })}
        />
      </div>
      <div className={styles.field}>
        <label>{t('ordersPage.reason')}</label>
        <textarea
          className="unv-input"
          rows={3}
          value={drawer.reason || ''}
          onChange={(e) => setDrawer({ ...drawer, reason: e.target.value })}
        />
      </div>
      <div className={styles.field}>
        <label>{t('ordersPage.body')}</label>
        <textarea
          className="unv-input"
          rows={6}
          value={drawer.body || ''}
          onChange={(e) => setDrawer({ ...drawer, body: e.target.value })}
          placeholder={t('ordersPage.bodyPlaceholder')}
        />
      </div>
      {drawer.kind === 'course_advance' && (
        <div className={styles.field}>
          <label>{t('ordersPage.newCourse')}</label>
          <input
            type="number"
            className="unv-input"
            value={drawer.extra_data?.new_course || ''}
            onChange={(e) =>
              setDrawer({
                ...drawer,
                extra_data: { ...(drawer.extra_data || {}), new_course: Number(e.target.value) },
              })
            }
          />
        </div>
      )}
      {(drawer.kind === 'transfer' || drawer.kind === 'course_advance') && (
        <div className={styles.field}>
          <label>{t('ordersPage.newGroupId')}</label>
          <input
            type="number"
            className="unv-input"
            value={drawer.extra_data?.new_group_id || ''}
            onChange={(e) =>
              setDrawer({
                ...drawer,
                extra_data: { ...(drawer.extra_data || {}), new_group_id: Number(e.target.value) },
              })
            }
          />
        </div>
      )}
      <div className={styles.actions}>
        <button className="unv-btn" onClick={onCancel}>{t('ordersPage.cancel')}</button>
        <button className="unv-btn unv-btn--primary" onClick={onCreate} disabled={busy}>
          {t('ordersPage.create')}
        </button>
      </div>
    </>
  )
}

export default OrderCreateForm
